var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3771 10.7866H19.3771V4.78662H20.3771V2.78662H4.37708V4.78662H5.37708V10.7866H3.37708C3.11186 10.7866 2.8575 10.892 2.66997 11.0795C2.48243 11.2671 2.37708 11.5214 2.37708 11.7866V20.7866H22.3771V11.7866C22.3771 11.5214 22.2717 11.2671 22.0842 11.0795C21.8966 10.892 21.6423 10.7866 21.3771 10.7866ZM14.3771 18.7866V14.7866H10.3771V18.7866H7.37708V4.78662H17.3771V18.7866H14.3771Z",
    fill: "#FEC200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37708 6.78662H11.3771V8.78662H9.37708V6.78662ZM13.3771 6.78662H15.3771V8.78662H13.3771V6.78662ZM9.37708 10.7866H11.3771V12.7866H9.37708V10.7866ZM13.3771 10.7866H15.3771V12.7866H13.3771V10.7866Z",
    fill: "#FEC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolStats);
export default __webpack_public_path__ + "static/media/schoolStats.d5964d6195c9c24e5ecf9a27c0fb2480.svg";
export { ForwardRef as ReactComponent };